import React from "react";
import { CampaignHero, OutcomeCTA } from "../components/CampaignHero";
import { IndustryCollection } from "../components/IndustryCollection";

export default function IndustriesPage({ onDemo }) {
  return <main data-testid="industries-page" className="campaign-page">
    <CampaignHero id="industries" image="industries" eyebrow="Helios across 15 industries" title={"Different worlds.\nOne question."} description="What are you trying to achieve? Explore how Helios connects decisions to the reality of your industry." to="/industries#industry-collection" primary="Find your industry" footer="You define the outcome. Helios finds the path." />
    <IndustryCollection />
    <OutcomeCTA onDemo={onDemo} id="industries" />
  </main>;
}